import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RequestResponse } from "../model/dto/RequestResponse";
import { TransferConsigmentDto } from "../model/dto/TransferConsigmentDto";

@Injectable()
export class TransferConsigmentFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    GetCollectionConsigmentByStore(storeOriginId: number, storeDestinationId: number,organizationId: string):
    Observable<RequestResponse<TransferConsigmentDto[]>> {
        return this._httpClient.get<RequestResponse<TransferConsigmentDto[]>>(this._urlBase + 'api/TransferStore/Consigment?storeOriginId='
            + storeOriginId + '&storeDestinationId=' + storeDestinationId +'&organizationId='+organizationId);
    }
}